var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vix-button-line',[_c('vix-button',{on:{"click":_vm.open}},[_vm._v(" "+_vm._s(_vm.buttonText || '立即开启')+" "),_c('span',{staticClass:"bubble"},[_c('pgy-common-sdk',{attrs:{"pos-id":11734,"env":_vm.runtime,"adType":"CSR_SSR","utm_source":_vm.utmSource,"swimlane":"1944-qmnfi"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }